import { render, staticRenderFns } from "./QATester.vue?vue&type=template&id=fbad7838"
import script from "./QATester.vue?vue&type=script&lang=js"
export * from "./QATester.vue?vue&type=script&lang=js"
import style0 from "./QATester.vue?vue&type=style&index=0&id=fbad7838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports